import React from 'react';

/** Spinner — centered by default. Pass inline={true} for inline usage. */
const Spinner = ({ inline = false }) =>
  inline ? (
    <span className="spinner spinner--sm" />
  ) : (
    <div className="spinner-wrap">
      <div className="spinner" />
    </div>
  );

export default Spinner;
